export { Panel as default } from 'rc-collapse';
